"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDirectionClass = void 0;

var _constants = require("./constants");

/** @function
 * @name getDirectionClass
 * Get the direction css class.
 * @param {String} direction
 * @returns {String} returns class
 */
var getDirectionClass = function getDirectionClass(direction) {
  return direction === _constants.enumDirection.VERTICAL ? _constants.enumDirectionClass.VERTICAL : _constants.enumDirectionClass.HORIZONTAL;
};

exports.getDirectionClass = getDirectionClass;
//# sourceMappingURL=utils.js.map